import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// includes
import * as setting from 'src/app/modules/siteSettings/components/settings'
import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import DynamicSettings from './../../../../common/components/settings'
import {BANK_SETTING_TYPE} from '../constants'

const BankSettings = () => {
  const dispatch = useDispatch()
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  useEffect(() => {
    dispatch(setting.actions.getSettingType())
  }, [])

  // backend stores the type as 'banksettings' and returns it ucwords-ed as 'Banksettings'
  const settingType: any = settingTypeData?.data?.settingType
    ? settingTypeData?.data?.settingType?.find(
        (item: any) => item?.name?.toLowerCase() === BANK_SETTING_TYPE.toLowerCase()
      )
    : {}

  return (
    <>
      <DynamicSettings
        settingTypeId={settingType?.id}
        settingName='Bank Settings'
        settingTypeName={settingType?.name}
      />
    </>
  )
}

export default BankSettings
